module.exports = __webpack_public_path__ + "img/undraw_business_decisions_gjwy.7ae7cf27.svg";